import { gql } from "@apollo/client";

export const CREATE_INVOICE = gql`
  mutation createinVoice($input: createinVoiceInput) {
    createinVoice(input: $input) {
      inVoiceId
      qrCodeUrl
    }
  }
`;
export const CREATE_INVOICE_ORG = gql`
  mutation CreateinVoiceOrg($input: createinVoiceOrgInput) {
    createinVoiceOrg(input: $input) {
      inVoiceId
    }
  }
`;

export const GET_INVOICE_ORG = gql`
  query inVoiceByOrg($orgId: Int!) {
    inVoiceByOrg(orgId: $orgId) {
      inVoiceId
      prospectId
      prospect
      Date
      dueDate
      Services
      servicesInvoice
      invoiceCountry
      clientDetails {
        clientId
        name
      }
      vendorDetails {
        vendorId
        name
      }
      invoiceDate
      recurringInvoice
      recurringStartDate
      recurringEndDate
      recurringFrequency
      amountPerCycle
      lastInvoiceAmount
      emailTo
      PAN
      address
      gstNumber
      gstType
      applicantId
      jobId
      orgId
      paymentStatus
      selectedOrg
      serviceName
      badDebt
      recurringCycles
      baseinvoiceId
      qrCodeUrl
      createdAt
    }
  }
`;
export const GET_ORG_INVOICES = gql`
  query AllOrgInvoices {
    allOrgInvoices {
      inVoiceId
      Date
      dueDate
      servicesInvoice
      invoiceCountry
      PAN
      address
      gstNumber
      gstType
      orgId
      paymentStatus
      badDebt
      selectedOrg
      serviceName
      orgDetails {
        name
      }
      createdAt
    }
  }
`;

export const GET_INVOICE_BY_ID = gql`
  query inVoice($inVoiceId: String!) {
    inVoice(inVoiceId: $inVoiceId) {
      inVoiceId
      prospectId
      prospect
      Date
      dueDate
      Services
      servicesInvoice
      clientDetails {
        clientId
        name
      }
      vendorDetails {
        vendorId
        name
      }
      invoiceDate
      recurringInvoice
      recurringStartDate
      recurringEndDate
      recurringFrequency
      amountPerCycle
      lastInvoiceAmount
      emailTo
      PAN
      address
      gstNumber
      gstType
      applicantId
      jobId
      orgId
      invoiceCountry
      paymentStatus
      badDebt
      selectedOrg
      serviceName
      recurringCycles
      baseinvoiceId
      qrCodeUrl
      createdAt
    }
  }
`;

export const UPDATE_INVOICE = gql`
  mutation updateinVoice($input: updateinVoiceInput) {
    updateinVoice(input: $input)
  }
`;

export const DELETE_INVOICE = gql`
  mutation deleteinVoice($inVoiceId: String) {
    deleteinVoice(inVoiceId: $inVoiceId)
  }
`;
export const SEND_INVOICE_EMAIL = gql`
  mutation SendInvoiceEmail($input: SendInvoiceEmailInput!) {
    sendInvoiceEmail(input: $input) {
      Id
    }
  }
`;

export const SAVE_OR_UPDATE_INVOICE_HEADER_STYLE = gql`
  mutation SaveOrUpdateInvoiceHeaderStyle($input: invoiceHeaderStyleInput!) {
    saveOrUpdateInvoiceHeaderStyle(input: $input) {
      orgId
      styles
    }
  }
`;

export const GET_INVOICE_HEADER_STYLE = gql`
  query GetInvoiceHeaderStyle($orgId: Int!) {
    getInvoiceHeaderStyle(orgId: $orgId) {
      orgId
      styles
    }
  }
`;
export const GET_INVOICE_REPORTS = gql`
  query GetInvoiceReports($from: String, $to: String) {
    getInvoiceReports(from: $from, to: $to) {
      inVoiceId
      prospect
      Date
      dueDate
      servicesInvoice
      clientDetails {
        name
      }
      paymentStatus
      createdAt
    }
  }
`;
